export default __webpack_public_path__ + "static/media/video.bfffebfc.png";